// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__e3Xtq","productName":"Table_productName__2VfVu"};